import React from "react";

import AdminUsersFeature from "../features/admin/user";

function AdminUsers(props) {
  return <AdminUsersFeature {...props} />;
}

export default AdminUsers;
